export const NavigationWidth = {
  Normal: '280px',
  Compact: '78px',
};

export const getNavigationWidth = (compact: boolean): string => {
  return compact ? NavigationWidth.Compact : NavigationWidth.Normal;
};
